module.exports = __webpack_public_path__ + "static/img/cont2402.fdc5a35.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont2402.jpg
// module id = Gn5z
// module chunks = 0